import Wizard from '@/generated/classes/Wizard';
export default class WizardExtend extends Wizard {
  constructor() {
    super();
  }
}
